import { Reveal, Overline } from "./Reveal";
import { SERVICES, APPLICATIONS } from "../lib/site";
import { scrollToId } from "../lib/scroll";
import { ArrowUpRight } from "lucide-react";

export const Services = () => (
  <section id="services" data-testid="services-section" className="scroll-mt-20 bg-lec-bone">
    <div className="mx-auto max-w-7xl px-5 py-20 md:px-10 md:py-28">
      <Reveal>
        <Overline>What we pour</Overline>
        <h2 className="mt-6 max-w-3xl font-display text-4xl font-semibold tracking-tight text-lec-ink sm:text-5xl lg:text-6xl">
          Four finishes. One standard: <span className="underline decoration-lec-green decoration-8 underline-offset-8">done right.</span>
        </h2>
        <p className="mt-6 max-w-2xl text-base text-lec-charcoal md:text-lg">
          Pool surrounds, patios, driveways, pathways and alfresco areas — every finish below,
          poured and finished by our own team.
        </p>
      </Reveal>

      <div className="mt-16">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={0.05}>
            <div
              data-testid={`service-item-${s.num}`}
              className="grid items-center gap-8 border-t border-lec-ink/15 py-12 md:grid-cols-12 md:gap-12 md:py-16"
            >
              <div className={`md:col-span-5 ${i % 2 ? "md:order-2" : ""}`}>
                <div className="group relative overflow-hidden [clip-path:polygon(0_0,100%_0,100%_calc(100%-32px),calc(100%-32px)_100%,0_100%)]">
                  <img
                    src={s.img}
                    alt={`${s.title} by Leading Edge Concrete Perth`}
                    loading="lazy"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <span className="absolute left-4 top-4 bg-lec-green px-3 py-1 font-display text-xs font-bold tracking-[0.2em] text-lec-ink">
                    {s.num}
                  </span>
                </div>
              </div>
              <div className={`md:col-span-7 ${i % 2 ? "md:order-1" : ""}`}>
                <h3 className="font-display text-2xl font-semibold tracking-tight text-lec-ink sm:text-3xl">
                  {s.title}
                </h3>
                <p className="mt-4 max-w-xl text-base leading-relaxed text-lec-charcoal">{s.blurb}</p>
                <div className="mt-6 flex flex-wrap gap-2">
                  {s.tags.map((t) => (
                    <span
                      key={t}
                      className="border border-lec-ink/20 px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.15em] text-lec-charcoal"
                    >
                      {t}
                    </span>
                  ))}
                </div>
                <button
                  data-testid={`service-quote-link-${s.num}`}
                  onClick={() => scrollToId("#quote")}
                  className="group mt-8 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-lec-ink transition-colors duration-200 hover:text-lec-green"
                >
                  Request a Quote
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                </button>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal>
        <div className="mt-8 flex flex-wrap items-baseline gap-x-6 gap-y-2 border-t border-lec-ink/15 pt-10" data-testid="applications-strip">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-lec-charcoal">Also pouring</span>
          {APPLICATIONS.map((a) => (
            <span key={a} className="font-display text-xl font-semibold text-lec-ink/30 transition-colors duration-300 hover:text-lec-ink md:text-2xl">
              {a}
            </span>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
